import { ACCOUNTING_CUSTOMERS_ACTION_TYPE } from '../actions';

const initialState = null;

const customersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACCOUNTING_CUSTOMERS_ACTION_TYPE.GET_CUSTOMERS:
      return payload || state;

    default:
      return state;
  }
};

export default customersReducer;
